import { registerQuery, useQuery } from 'data-fetching-client';
import apiClient from 'hub-http/clients/apiClient';
const PortalUserCountQuery = registerQuery({
  fieldName: 'portalUserCount',
  args: [],
  fetcher: () => {
    return apiClient.put('users-search/v1/users-search/app/search', {
      data: {
        offset: 0,
        count: 0
      }
    });
  }
});
export const useFetchPortalUserCount = () => {
  var _data$portalUserCount;
  const {
    data,
    loading,
    error
  } = useQuery(PortalUserCountQuery);
  return {
    data: data === null || data === void 0 || (_data$portalUserCount = data.portalUserCount) === null || _data$portalUserCount === void 0 ? void 0 : _data$portalUserCount.total,
    loading,
    error
  };
};